import React from "react";
import "../../styles/index.less";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

const Footer: React.FC = () => {
  const logo: string = new URL("../../assets/logo3.png", import.meta.url).href;

  return (
    <footer className="footer">
      <div className="footer__container">
        {/* Left Section */}
        <div className="footer__left">
          <img src={logo} alt="CareEdge Logo" className="footer__logo" />

          <div className="footer__box">
            <p>
              CareEdge Analytics is a leading player in providing risk analytics
              & consulting services to banks and financial institutions (BFSI).
            </p>

            <div className="footer__divider" />

            <div className="footer__section">
              <h3>Our Office Address</h3>
              <p>
                Tropical New Era Business Park, 9th Floor, Road No. 33 Wagle
                Industrial Estate, Opp ESIS Kamagar Hospital Thane West, Thane,
                Maharashtra - 400604
              </p>
            </div>

            <div className="footer__divider" />

            <div className="footer__section">
              <h3>For General Inquiries</h3>
              <p>
                <a href="mailto:caaplanalytics.sales@careedge.in">
                  caaplanalytics.sales@careedge.in
                </a>
              </p>
            </div>
          </div>
        </div>
        {/* Right Section */}
        <div className="footer__right">
          <p className="footer__insights">
            Weekly industry insights delivered to your inbox.
          </p>

          <div className="footer__subscribe">
            <input type="email" placeholder="Add your email address" />
            <button>SUBSCRIBE</button>
          </div>

          <div className="footer__cta">
            <h2>
              Start your investing <br /> journey today.
            </h2>
            <button className="footer__btn">Get Started</button>
          </div>
        </div>
      </div>
      <div className="footer__navrow">
        <div className="footer__nav">
          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            About Us
          </NavLink>

          <NavLink
            to="/reits"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            REITs
          </NavLink>

          <NavLink
            to="/invits"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            InvITs
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Contact Us
          </NavLink>
        </div>
        <div className="footer__fullline" />
      </div>

      {/* Bottom row */}
      <div className="footer__bottom">
        <div className="footer__leftbottom">
          <p>© 2025 All rights reserved.</p>
          <a href="#">Terms & Conditions</a>
          <a href="#">Privacy Policy</a>
        </div>

        <div className="footer__rightbottom">
          <a
            href="https://caapl.in/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Website"
          >
            <FontAwesomeIcon icon={faGlobe} size="lg" />
          </a>
          <a
            href="https://www.linkedin.com/company/careedgeanalytics/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FontAwesomeIcon icon={faLinkedinIn} size="lg" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
